/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AssessmentTypeEnum = {
    INPUT: 'INPUT',
    OUTPUT: 'OUTPUT',
    PERIOD: 'PERIOD',
    REGULAR: 'REGULAR',
    IMPORT: 'IMPORT'
} as const;
export type AssessmentTypeEnum = typeof AssessmentTypeEnum[keyof typeof AssessmentTypeEnum];

